export const getSpAttributes = () => [
  {
    prop: "id",
    label: "ID остановки",
    type: "input",
    disabled: true
  },
  {
    prop: "name",
    label: "Название остановки",
    type: "input"
  },
  {
    prop: "is_active",
    label: "Статус остановочного пункта",
    type: "switch",
    labelTrue: "Активен",
    labelFalse: "Не активен"
  },
  {
    prop: "transport_type",
    label: "Тип транспорта",
    type: "checkbox-group",
    values: "transportTypes"
  },
  {
    prop: "on_demand",
    label: "Остановка по требованию",
    type: "switch",
    labelTrue: "Да",
    labelFalse: "Нет"
  },
  {
    prop: "distance_class",
    label: "Группа маршрутов",
    type: "checkbox-group",
    values: "distanceClasses"
  }
  // {
  //   prop: "transport_systems",
  //   label: "Системы траснпорта",
  //   values: "transportSystems",
  //   request: ids["transport_systems"],
  //   type: "checkbox-group"
  // }
];

export const getRouteAttributes = ids => [
  {
    prop: "name",
    label: "Название маршрута",
    type: "input"
  },
  {
    prop: "number",
    label: "Номер маршрута",
    type: "input"
  },
  {
    prop: "rev",
    label: "Направление",
    type: "rev"
  },
  {
    prop: "distance_class",
    label: "Класс маршрута",
    type: "select",
    values: "distanceClasses"
  },
  {
    prop: "transfer_type",
    label: "Вид перевозок",
    type: "select",
    values: "transferTypes"
  },
  {
    prop: "transport_system_id",
    label: "Система траснпорта",
    values: "transportSystems",
    request: ids["transport_systems"],
    type: "select"
  },
  {
    prop: "carrier_id",
    label: "Перевозчик",
    type: "select",
    values: "carriers"
  },
  {
    prop: "geom_length",
    label: "Протяженность",
    type: "input",
    disabled: true
  },
  {
    prop: "start_stop_point_name",
    label: "Начальный остановочный пункт",
    type: "input",
    disabled: true
  },
  {
    prop: "end_stop_point_name",
    label: "Конечный остановочный пункт",
    type: "input",
    disabled: true
  }
];

export const values = {
  transportTypes: [
    {
      id: 1,
      name: "Безрельсовые"
    },
    {
      id: 2,
      name: "Рельсовые"
    }
  ],
  transferTypes: [
    {
      id: 1,
      name: "Регулируемые"
    },
    {
      id: 2,
      name: "Нерегулируемые"
    }
  ],
  distanceClasses: [
    {
      id: 1,
      name: "Городские"
    },
    {
      id: 2,
      name: "Пригородные"
    },
    {
      id: 3,
      name: "Междугородние"
    }
  ],
  carriers: [],
  transportSystems: []
};
